
import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import { useAuthSession } from '@/hooks/useAuthSession';
import { useAuthActions } from '@/hooks/useAuthActions';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/auth';

// Import our new components
import AuthWelcomeHeader from '@/components/auth/AuthWelcomeHeader';
import AuthContentTabs from '@/components/auth/AuthContentTabs';
import AuthRedirectHandler from '@/components/auth/AuthRedirectHandler';
import PendingTripHandler from '@/components/auth/PendingTripHandler';

const Auth = () => {
  const { isUpgrading } = useAuthSession();
  const {
    loading,
    handleSignIn,
    handleSignUp,
    handleForgotPassword
  } = useAuthActions();
  const { user } = useAuth();
  const location = useLocation();
  const [defaultTab] = useState<string>('signin');
  
  // Check if we were redirected from "Join Trip"
  const isJoiningTrip = sessionStorage.getItem('pendingTripCode') !== null;
  const pendingTripName = sessionStorage.getItem('pendingTripName');
  
  // Check if we were redirected for password reset
  const isResettingPassword = new URLSearchParams(location.search).get('reset') === 'true';

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-light p-4">
      {/* Handle auth redirects */}
      <AuthRedirectHandler />
      
      {/* Handle pending trip joins */}
      <PendingTripHandler user={user} />
      
      <Card className="w-full max-w-md shadow-lg">
        {/* Welcome header with context-aware messages */}
        <AuthWelcomeHeader 
          isUpgrading={isUpgrading}
          isJoiningTrip={isJoiningTrip}
          pendingTripName={pendingTripName}
          isResettingPassword={isResettingPassword}
        />
        
        {/* Auth forms with tabs */}
        <AuthContentTabs
          handleSignIn={handleSignIn}
          handleSignUp={handleSignUp}
          handleForgotPassword={handleForgotPassword}
          loading={loading}
          defaultTab={defaultTab}
        />
      </Card>
    </div>
  );
};

export default Auth;
